'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _extendableBuiltin(cls){function ExtendableBuiltin(){var instance=Reflect.construct(cls,Array.from(arguments));Object.setPrototypeOf(instance,Object.getPrototypeOf(this));return instance}ExtendableBuiltin.prototype=Object.create(cls.prototype,{constructor:{value:cls,enumerable:!1,writable:!0,configurable:!0}});if(Object.setPrototypeOf){Object.setPrototypeOf(ExtendableBuiltin,cls)}else{ExtendableBuiltin.__proto__=cls}return ExtendableBuiltin}

const _=require('pulsar-utils/dist-es6/_');
const Entity=require('pulsar-utils/dist-es6/domain/entity');let

InvalidNameError=function(_extendableBuiltin2){_inherits(InvalidNameError,_extendableBuiltin2);
function InvalidNameError(message){_classCallCheck(this,InvalidNameError);var _this=_possibleConstructorReturn(this,
_extendableBuiltin2.call(this));
_this.message=message;return _this;
}return InvalidNameError}(_extendableBuiltin(Error));


const MinNameLength=1;
const MaxNameLength=50;

const MinFatigueThreshold=5;
const MaxFatigueThreshold=21;

const MinDeviationThreshold=1;
const MaxDeviationThreshold=3;let

Group=function(_Entity){_inherits(Group,_Entity);_createClass(Group,null,[{key:'MinNameLength',get:function()
{
return MinNameLength;
}},{key:'MaxNameLength',get:function()

{
return MaxNameLength;
}},{key:'MinFatigueThreshold',get:function()

{
return MinFatigueThreshold;
}},{key:'MaxFatigueThreshold',get:function()

{
return MaxFatigueThreshold;
}},{key:'MinDeviationThreshold',get:function()

{
return MinDeviationThreshold;
}},{key:'MaxDeviationThreshold',get:function()

{
return MaxDeviationThreshold;
}}]);

function Group(name,personIds,fatigueThreshold,deviationThreshold,creationTime,underConstruction,id){_classCallCheck(this,Group);var _this2=_possibleConstructorReturn(this,
_Entity.call(this,id));
_this2.setName(name);
_this2._personIds=_.uniqBy(personIds,function(personId){return personId.toString()});
_this2.fatigueThreshold=fatigueThreshold;
_this2.deviationThreshold=deviationThreshold;

_.ensureInstanceOf([Date,'nullable'],creationTime);
_.ensureInstanceOf('boolean',underConstruction);
_this2._creationTime=creationTime;
_this2._underConstruction=underConstruction;return _this2;
}Group.prototype.

setName=function setName(name){
if(name.length<MinNameLength||name.length>MaxNameLength){
throw new InvalidNameError;
}
this._name=name;
};Group.













































tryGetValidFatigueThreshold=function tryGetValidFatigueThreshold(fatigueThreshold){
_.ensureInstanceOf(['number','nullable'],fatigueThreshold);
if(!_.exists(fatigueThreshold)){
return null;
}

if(fatigueThreshold<MinFatigueThreshold||fatigueThreshold>MaxFatigueThreshold){
throw new Error(`'fatigueThreshold' out of acceptable range (${fatigueThreshold} is not between ${MinFatigueThreshold} and ${MaxFatigueThreshold})`);
}

if(!_.isInteger(fatigueThreshold)){
throw new Error(`'fatigueThreshold' is not an integer`);
}

return fatigueThreshold;
};Group.

tryGetValidDeviationThreshold=function tryGetValidDeviationThreshold(deviationThreshold){
_.ensureInstanceOf(['number','nullable'],deviationThreshold);
if(!_.exists(deviationThreshold)){
return null;
}

if(deviationThreshold<MinDeviationThreshold||deviationThreshold>MaxDeviationThreshold){
throw new Error(`'deviationThreshold' out of acceptable range (${deviationThreshold} is not between ${MinDeviationThreshold} and ${MaxDeviationThreshold})`);
}

if(!_.isInteger(deviationThreshold)){
throw new Error(`'deviationThreshold' is not an integer`);
}

return deviationThreshold;
};Group.prototype.

addPersonIds=function addPersonIds(personIds){
_.pushMany(this._personIds,personIds);
this._personIds=_.uniqBy(this._personIds,function(personId){return personId.toString()});
};Group.prototype.

removePersonIds=function removePersonIds(personIdsToRemove){
_.remove(this._personIds,function(personId){return _(personIdsToRemove).some(function(toRemove){return toRemove.equals(personId)})});
};_createClass(Group,[{key:'name',get:function(){return this._name}},{key:'personIds',get:function(){return this._personIds.slice()}},{key:'fatigueThreshold',get:function(){return this._fatigueThreshold},set:function(fatigueThreshold){this._fatigueThreshold=Group.tryGetValidFatigueThreshold(fatigueThreshold)}},{key:'deviationThreshold',get:function(){return this._deviationThreshold},set:function(deviationThreshold){this._deviationThreshold=Group.tryGetValidDeviationThreshold(deviationThreshold)}},{key:'creationTime',get:function(){return this._creationTime},set:function(val){throw new Error('can only be set from constructor')}},{key:'underConstruction',get:function(){return this._underConstruction},set:function(val){if(val!==!1){throw new Error('underConstruction can only be unset')}this._underConstruction=!1}}]);return Group}(Entity);


module.exports=Group;
module.exports.InvalidNameError=InvalidNameError;
//# sourceMappingURL=group.js.map
